import { Link } from "react-router-dom";
import { Facebook, Instagram, Mail, MapPin, Phone } from "lucide-react";
import { useLang } from "../context/LanguageContext";

const Footer = () => {
  const { t } = useLang();

  return (
    <footer className="bg-navy text-paper" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-12 px-4 py-16 sm:px-8 md:grid-cols-3">
        <div>
          <p className="font-cinzel text-lg font-bold tracking-[0.18em]">THE VALDIVIESO GROUP</p>
          <p className="mt-1 text-[10px] font-semibold uppercase tracking-[0.3em] text-gold">
            DV Luxury Realty
          </p>
          <p className="mt-6 max-w-xs text-sm leading-relaxed text-paper/70">
            {t("ft.tagline")}
          </p>
        </div>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-gold">{t("ft.contact")}</p>
          <ul className="mt-5 space-y-3 text-sm text-paper/80">
            <li>
              <a href="tel:+17022414761" data-testid="footer-phone-link" className="flex items-center gap-3 transition-colors hover:text-gold">
                <Phone size={14} className="text-gold" /> 702 · 241 · 4761
              </a>
            </li>
            <li>
              <a href="mailto:AceEdwardsLV@gmail.com" data-testid="footer-email-link" className="flex items-center gap-3 transition-colors hover:text-gold">
                <Mail size={14} className="text-gold" /> AceEdwardsLV@gmail.com
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={14} className="mt-1 shrink-0 text-gold" />
              <span>1325 S Eastern Ave<br />Las Vegas, NV 89104</span>
            </li>
            <li className="flex items-center gap-4 pt-2">
              <a
                href="https://www.facebook.com/onyrealtor/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook-link"
                aria-label="Facebook"
                className="border border-white/20 p-2.5 text-paper/70 transition-colors hover:border-gold hover:text-gold"
              >
                <Facebook size={16} />
              </a>
              <a
                href="https://www.instagram.com/onyvaldivieso_realtor/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-link"
                aria-label="Instagram"
                className="border border-white/20 p-2.5 text-paper/70 transition-colors hover:border-gold hover:text-gold"
              >
                <Instagram size={16} />
              </a>
            </li>
          </ul>
        </div>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-gold">{t("ft.explore")}</p>
          <ul className="mt-5 space-y-3 text-sm text-paper/80">
            <li><Link to="/listings" data-testid="footer-listings-link" className="transition-colors hover:text-gold">{t("ft.currentListings")}</Link></li>
            <li><Link to="/listings?status=sold" data-testid="footer-sold-link" className="transition-colors hover:text-gold">{t("ft.recentlySold")}</Link></li>
            <li><Link to="/admin/login" data-testid="footer-agent-portal-link" className="transition-colors hover:text-gold">{t("ft.agentPortal")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center gap-5 px-4 py-9 sm:px-8">
          <p className="text-[10px] font-semibold uppercase tracking-[0.35em] text-gold">{t("ft.partners")}</p>
          <img
            src="/landmark-logo.png"
            alt="Landmark Title Assurance Agency — A Shaddock Company"
            data-testid="footer-partner-landmark"
            className="h-12 w-auto opacity-95 sm:h-14"
          />
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-[11px] uppercase tracking-[0.2em] text-paper/50 sm:flex-row sm:px-8">
          <span>O. Valdivieso Lic. #S.0061852 · A. Edwards Lic. #S.0200120 · N. Rankin Lic. #S.0200905</span>
          <span>© {new Date().getFullYear()} DV Luxury Realty · Equal Housing Opportunity</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
